var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 20,
    viewBox: "0 0 31 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.86 0L21.013 19.2499H11.7639L15.8848 11.2719H15.6999C12.3002 15.6853 7.2276 18.5906 0 19.2499V11.3824C0 11.3824 4.62367 11.1092 7.3418 8.25154H0V0.000151837H8.25139V6.7868L8.43658 6.78604L11.8084 0.000151837H18.0487V6.74377L18.2339 6.74347L21.7322 0H30.86Z",
    fill: "#146EF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector11);
export default __webpack_public_path__ + "static/media/Vector-1-1.f58b062ad126bb0cee01be6e8303eaa2.svg";
export { ForwardRef as ReactComponent };